import { ArrowRight } from "lucide-react";
import LeadDialog from "@/components/site/LeadDialog";

export default function CTABanner() {
    return (
        <section data-testid="cta-banner" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <div className="relative overflow-hidden rounded-3xl border hairline bg-ink text-white p-10 md:p-16 grain">
                    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-gold/20 blur-3xl" />
                    <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-royal/30 blur-3xl" />

                    <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
                        <div className="lg:col-span-8">
                            <div className="flex items-center gap-3 mb-5">
                                <span className="divider-gold" />
                                <span className="uppercase tracking-[0.28em] text-xs text-gold font-medium">
                                    Start Your Project
                                </span>
                            </div>
                            <h3 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tight">
                                Ready to experience your dream{" "}
                                <span className="italic text-gold">before</span> construction begins?
                            </h3>
                            <p className="mt-5 max-w-2xl text-white/70">
                                Book a complimentary consultation. We&apos;ll review your site, needs,
                                and budget — and show you exactly what&apos;s possible.
                            </p>
                        </div>
                        <div className="lg:col-span-4 flex lg:justify-end">
                            <LeadDialog
                                trigger={
                                    <button
                                        data-testid="cta-banner-btn"
                                        className="group inline-flex items-center gap-2 h-14 px-8 rounded-full bg-gold text-white text-base font-medium hover:brightness-110 transition"
                                    >
                                        Start Your Project Today
                                        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                                    </button>
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
